import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
const stats = [{
  number: '+500',
  label: 'Clients Transformed'
}, {
  number: '5.0',
  label: 'Stars on Google'
}, {
  number: '100%',
  label: 'Hair Texture Specialists'
}];
export function AuthoritySection() {
  return <section className="py-20 px-4 bg-dark border-y border-gold/10" data-id="element-13">
      <div className="max-w-5xl mx-auto text-center" data-id="element-14">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-display text-2xl md:text-4xl text-white mb-16" data-id="element-15">
          Why Axel Cut & Style Studio Is the{' '}
          <span className="text-gold italic" data-id="element-16">Premium Standard</span> in Passaic
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16" data-id="element-17">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center" data-id="element-18">
              <span className="font-display text-5xl md:text-6xl text-gold mb-2 font-bold" data-id="element-19">
                {stat.number}
              </span>
              <span className="font-body text-cream/80 uppercase tracking-widest text-sm font-medium" data-id="element-20">
                {stat.label}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="bg-matte p-8 rounded-xl border border-gold/20 inline-block w-full max-w-2xl" data-id="element-21">
          <p className="font-body text-cream mb-4 font-light text-lg" data-id="element-22">
            We come to you! Home service available.
          </p>
          <a href="tel:8623889571" className="flex items-center justify-center gap-3 text-gold hover:text-gold-light transition-colors group" data-id="element-23">
            <PhoneIcon className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-24" />
            <span className="font-display text-2xl md:text-3xl tracking-wide" data-id="element-25">
              862-388-9571
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}